'use strict';

var React = require('react');
var SimplePostArticleModule  = require('./simple-post-article.jsx');
var EspecialPublicitarioPost  = require('./especial-publicitario.jsx');


var SimplePostArticle  = SimplePostArticleModule.SimplePostArticle;

var PostArticle = React.createClass({
    render: function() {
        if (this.props.pubeditorial)
            return <EspecialPublicitarioPost {...this.props} />;
        else
            return <SimplePostArticle {...this.props} />;
    }
});

module.exports = PostArticle;
